
import Vue from 'vue'
import {Component,Mixins} from 'vue-property-decorator'
//import { BModal } from  'bootstrap-vue';
import EventBus from '../../eventBus'
import { required } from 'vuelidate/lib/validators'
import { Validations } from 'vuelidate-property-decorators';
import UserProVisioning from "@/mixins/userProvisioning"

@Component
export default class BudgetingLines extends Mixins(UserProVisioning) {
    selectedRows: {name: string; id: string}[] = []
    selectAll: boolean = false

    @Validations()
    validations = {
        budgetLine: {
            lineItem: { required },
            lineSplit: {required}
        }
    }
    private error: string = '';
    private activeScreen: string = 'loading';
    private additionalSuccessMessage: string = '';
    private successMessage: string = '';
    private loadingMessage: string = '';
    private loadingTitle: string = '';
    private budgetLine: any = {
        lineItem: '',
        lineSplit:0.6
    };
    private search: string = '';
    private title: string = '';
    private deletePromptProperty: boolean = false;
    private activeItem: any = {};
    private isEdit : boolean = false;

    get fields(){
       if(this.canWriteBudgetSettings){
            return  [ 
                        { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" }},
                        { key: 'serial', label: 'S/N', sortable: false },
                        { key: 'lineItem', label: 'Name'},
                        { key: 'numberOfDependentTemplates', label: 'No of Dependent Templates'},
                        // { key: 'numberOfDependentProjects', label: 'No of Dependent Projects'},
                        { key: 'button', label: 'Actions'},
                    ];
        }
         return  [
                    { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" }},
                    { key: 'serial', label: 'S/N', sortable: false },
                    { key: 'lineItem', label: 'Name'},
                    { key: 'numberOfDependentTemplates', label: 'No of Dependent Templates'},
                    // { key: 'numberOfDependentProjects', label: 'No of Dependent Projects'},
                ];

    }

    private get getAllBudgetLines() {
        return (this.$store.getters['budgetLineModule/getAllBudgetLines'] || [])
            .slice()
            .sort((a: any, b: any) => {
            const itemA = (a.lineItem || '').toString().toLowerCase().trim();
            const itemB = (b.lineItem || '').toString().toLowerCase().trim();
            return itemA.localeCompare(itemB, undefined, {
                sensitivity: 'base', 
                numeric: true
            });
        });
    }

    private fetchBudgetLines () {
        return this.$store.dispatch('budgetLineModule/fetchBudgetLines')
    }

    private searchValue (e: any) {
        this.search = e;
    }

    toggleSelectAll() {
        if (!this.selectAll) {
            this.selectedRows = this.getAllBudgetLines.map((budgetLineItem: any) => ({id: budgetLineItem.id, name: budgetLineItem.lineItem}))
        } else {
            this.selectedRows = []
        }
    }

    private openForm() {
        this.isEdit = false
        this.budgetLine.lineItem = ''
        this.budgetLine.lineSplit = 0.6
        let formModal = this.$refs.budget as any;
        this.title = 'Create New Budget Line';
        formModal.show();
    }

    getBudgetLinesToDelete () {
        const names = this.selectedRows.map(row => row.name);

        let formattedNames = '';
        if (names.length <= 3) {
            const lastTwoNames = names.splice(-2);
            if (this.selectedRows.length === 2) {
                return formattedNames = `${names.join(', ')} ${lastTwoNames.join(' and ')}`;
            }
            return formattedNames = `${names.join(', ')}, ${lastTwoNames.join(' and ')}`;
        }
        else {
            const firstTwoNames = names.slice(0, 2);
            const remainingCount = names.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} budget line${remainingCount > 1 ? 's' : ''}`;
        }
    }

    private deleteBudgetLine() {
        const isMultipleDelete = this.selectedRows.length;
        this.activeScreen = 'loading'
        this.loadingMessage = 'Please wait while we delete this budget line'
        this.loadingTitle = 'Deleting...'
        EventBus.$emit('activeScreen', this.activeScreen)
        const payload = isMultipleDelete ? this.selectedRows.map(row => row.id) : [this.activeItem.id]

        this.$store.dispatch('budgetLineModule/deleteBudgetLineAction', payload).then(response => {
            this.activeScreen = 'successNoBack'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.additionalSuccessMessage = 'This budgetline will no longer be available'
            this.successMessage = `${isMultipleDelete ? 'Budget lines' : this.activeItem.lineItem} Deleted Successfully`
            this.successMessage = this.activeItem.lineItem + ' Deleted Successfully'
            this.selectedRows = []
            this.deletePromptProperty = false
        }, error => {          
            this.activeScreen = 'error'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.error = error.message
            this.deletePromptProperty = false
        })
    }

    save() {
        this.loadingMessage = 'Please wait while we save this budget line item';
        this.loadingTitle = 'Saving budget line item';
        this.$store.dispatch('budgetLineModule/createBudgetLineItem', this.budgetLine)
        .then((response: any) => {
            this.activeScreen = 'successNoBack';
            EventBus.$emit('activeScreen', this.activeScreen);
            this.additionalSuccessMessage = '';
            this.$v.$reset()
            this.successMessage = 'Successfully Created '+ this.budgetLine.lineItem;
        }). catch((error: any) => {
            this.activeScreen = 'error'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.error = error.response.data.data
            
            
        })
    }

    updateBudgetLine() {
        this.$store.dispatch('budgetLineModule/updateBudgetLines', this.budgetLine)
        .then((response: any) => {
            this.loadingMessage = 'Please wait while we update this budget line item';
            this.loadingTitle = 'Updating budget line item';
            this.activeScreen = 'successNoBack';
            EventBus.$emit('activeScreen', this.activeScreen);
            this.additionalSuccessMessage = '';
            this.successMessage = 'Budget Line Updated Successfully';
        }).catch((error:any) => {
            this.activeScreen = 'error'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.error = error.response.data.data
        })
    }

    private saveBudgetLine () {
        this.activeScreen = 'loading';
        EventBus.$emit('activeScreen', this.activeScreen);
        if (this.isEdit === false ){
            this.save()
        } else {
            this.updateBudgetLine()
        }        
    }

    private update(data: any) {
        this.isEdit = true;
        this.budgetLine.lineItem = data.lineItem;
        this.budgetLine.lineSplit = data.lineSplit
        this.budgetLine.id = data.id
        let formModal = this.$refs.budget as any;
        this.title = 'Update Budget Line';
        formModal.show();
    }

    private promptDelete(e: any) {
        this.activeItem = e;
        this.deletePromptProperty = true;
    }

    created () {
        this.loadingMessage = 'Loading Budget Lines';
        this.loadingTitle = 'Loading...';
        if (this.getAllBudgetLines.length == 0) {
            this.fetchBudgetLines().then((res: any) => {
                this.activeScreen = 'main'
                EventBus.$emit('activeScreen', this.activeScreen)
            })
        } else {
            this.activeScreen = 'main'
            EventBus.$emit('activeScreen', this.activeScreen)
        }
    }
}
